<template>
  <AuthView title="Login">
    <v-form :ref="setFormRef" @submit.prevent="login" >
      <EmailField v-model="email" />
      <TextField v-model="password" :rules="[required]" label="Password" type="password" />
      <AppBtn primary :loading type="submit">Login</AppBtn>
    </v-form>
  </AuthView>
</template>

<script setup lang="ts">
const { onAuthChange, signIn } = useAuth();
const { setFormRef, submit, loading } = useForm();
const { required } =  useValidation();

const email = ref('');
const password = ref('');

onAuthChange(state => {
  if (state == 'logged_in') {
    navigateTo('/admin');
  }
});

function login() {
  submit(async () => {
    await signIn(email.value, password.value);
  });
}
</script>